import Image from "next/image";
import styles from "../../styles/finance.module.css";
import useIsMobile from "../../hooks/useIsMobile";
import useWindowSize from "../../hooks/useWindowSize";
import { configuration } from "../../helpers/config";
import ReactPlayer from "react-player";
import React,{useState} from "react";
// import Skeleton from "react-loading-skeleton";
// import "react-loading-skeleton/dist/skeleton.css";
import { Constants } from "../../helpers/constants";

// Banner component for static pages.
const FinanceBanner = (props) => {
  const [isLoading, setIsLoading] = useState(true);
  const [isLoadingMobile, setIsLoadingMobile] = useState(true);
  const [hideImage, setHideImage] = useState(false);
  const mobile = useIsMobile();
  const windoWidth = useWindowSize();
    const [isPlaying, setIsPlaying] = useState(true);
      const [showInfo, setShowInfo] = useState(false);
      
      const togglePlayPause = () => {
        setIsPlaying(!isPlaying);
      };

  return (
    <>
      <div
        className={` ${styles.banner_image} bg-defaut-color container-fluid`}
        style={{ marginBottom: `${props.bannerClass}`}}
      >
       <div className={styles.banner}>
          {mobile ? (
            props.videoMob ? (
               <div className="block lg:hidden" style={{ position: "relative", width: "100%", height: "60vh" }}>
                               <ReactPlayer
                                url={props.videoMob}
                                playing={isPlaying}
                                volume={0}
                                height="100%"
                                width="100%"
                                loop={true}
                                playsinline
                              />
                                                  
                                      {/* Play/Pause Button */}
                                      <button
                            onClick={togglePlayPause}
                            style={{
                              position: "absolute",
    bottom: "114px",
    right: "90px",
    backgroundColor: "white",
    color: "black",
    border: "2px solid #001151",
    borderRadius: "50%", // Circular
    cursor: "pointer",
    zIndex: 1,
    width: "40px",
    height: "40px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginRight:"10px",
    boxShadow: "0 2px 8px rgba(0,0,0,0.10)"
                            }}
                          >
                            <img
                              src={
                                isPlaying
                                  ? `${configuration.IMG_STATIC_URL}pause.svg`
                                  : `${configuration.IMG_STATIC_URL}Play.svg`
                              }
                              alt={isPlaying ? "Pause" : "Play"}
                              style={{ width: "24px", height: "24px" }}
                            />
                          </button>
                                  
                                      {/* Info Button */}
                                      <button
                            onClick={() => setShowInfo(true)}
                            style={{
                              position: "absolute",
    bottom: "116px",
    right: "20px",
    backgroundColor: "white",
    color: "black",
    border: "2px solid #001151",
    cursor: "pointer",
    zIndex: 1,
    width: "68px",
    height: "36px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    boxShadow: "0 2px 8px rgba(0,0,0,0.10)"
                            }}
                          >
                           {Constants.allcomponents.INFO}
                          </button>
                                  
                                      {/* Info Modal */}
                                      {showInfo && (
                                        <div
                                          style={{
                                            position: "absolute",
                                            top: "40%",
                                            left: "50%",
                                            transform: "translate(-50%, -50%)",
                                            backgroundColor: "#fff",
                                            padding: "20px",
                                            // borderRadius: "10px",
                                            boxShadow: "0 0 10px rgba(0,0,0,0.3)",
                                            zIndex: 10,
                                            width: "300px",
                                            height:"300px",
                                            
                                          }}
                                        >
                                           <div className="flex align">
                <p style={{ fontWeight: 400, fontFamily: "SuzukiPROBold", fontSize: "24px"  }}>{Constants.allcomponents.INFO_TITLE}</p>
                <button
                  onClick={() => setShowInfo(false)}
                  style={{
                    position: "absolute",
                    top: "10px",
                    right: "15px",
                    background: "none",
                    border: "none",
                    fontSize: "18px",
                    cursor: "pointer",
                  }}
                 aria-label="Close"
                 >
               <span aria-hidden="true" role="presentation">×</span>
                </button>
                </div>
                                          <div style={{
                     marginTop:"15px",
                     fontSize: "16px",
                     fontWeight: "400",
                     fontFamily: "SuzukiPROBold",
                    
                  }}>
                                          
                                            <p style={{overflow:"scroll",height:"220px"}}>{props?.mobile_info}</p>
                                          </div>
                                        </div>
                                      )}
                                    </div>
            ) : (
              <div style={{ height: "60vh" }}>  
               {/* {isLoadingMobile && !hideImage && <Skeleton height={1080} width={768} />} */}
               {!hideImage && (
              <Image
                src={props.imageMob}
                // height={!isLoadingMobile?1080:0}
                // width={!isLoadingMobile?768:0}
                objectFit="cover" 
                layout="fill" 
                alt={props?.page==="ro-history" ? props?.alt : props.alt_imageMob || (props?.imageMob ? `Suzuki_${props?.imageMob?.split("/").pop()?.split(".")[0]}` : "")}
                className={`${styles.bannerImage} ${isLoadingMobile ? "hidden" : "block"}`}
                onLoad={() => setIsLoadingMobile(false)}
                onError={() => setHideImage(true)}
              />
               )} 
              </div>
            )
          ) : props.video ? (
           
             <div style={{ position: "relative", width: "100%", height: "calc(100vh - 180px)" }}>
                              <ReactPlayer
                              url={props.video}
                              playing={isPlaying}
                              volume={0}
                              height={"calc(100vh - 180px)"}
                              width="100%"
                              loop={true}
                              playsinline
                            />
                                
                                    {/* Play/Pause Button */}
                                    <button
                                      onClick={togglePlayPause}
                                      style={{
                                        position: "absolute",
                                        bottom: "20px",
                                        right: "90px",
                                        padding:"6px",
                                        backgroundColor: "white",
                                        color: "black",
                                        border: "2px solid #001151", 
                                        borderRadius: "50px",
                                        cursor: "pointer",
                                        zIndex: 1,
                                        marginRight:"10px",
                                      }}
                                    >
                                      <img
                                        src={
                                          isPlaying
                                            ? `${configuration.IMG_STATIC_URL}pause.svg`
                                            : `${configuration.IMG_STATIC_URL}Play.svg`
                                        }
                                        alt={isPlaying ? "Pause" : "Play"}
                                        style={{ width: "24px", height: "24px" }}
                                      />
                                    </button>
                                
                                    {/* Info Button */}
                                    <button
                                      onClick={() => setShowInfo(true)}
                                      style={{
                                        position: "absolute",
                                        bottom: "23px",
                                        right: "20px",
                                        backgroundColor: "white",
                                        color: "black",
                                        border: "2px solid #001151", 
                                        
                                        cursor: "pointer",
                                        zIndex: 1,
                                        height:"36px",
                                        width:"68px",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                      }}
                                    >
                                   <span>{Constants.allcomponents.INFO}</span>
                                    </button>
                                
                                    {/* Info Modal */}
                                    {showInfo && (
                                      <div
                                        style={{
                                          position: "absolute",
                                          top: "40%",
                                          left: "50%",
                                          transform: "translate(-50%, -50%)",
                                          backgroundColor: "#fff",
                                          padding: "20px",
                                          // borderRadius: "10px",
                                          boxShadow: "0 0 10px rgba(0,0,0,0.3)",
                                          zIndex: 10,
                                          width: "700px",
                                        }}
                                      >
                                        <div className="flex align">
              <p style={{ fontWeight: 400, fontFamily: "SuzukiPROBold", fontSize: "24px"  }}>{Constants.allcomponents.INFO_TITLE}</p>
                <button
                  onClick={() => setShowInfo(false)}
                  style={{
                    position: "absolute",
                    top: "10px",
                    right: "15px",
                    background: "none",
                    border: "none",
                    fontSize: "24px",
                    cursor: "pointer",
                  }}
                 aria-label="Close"
                 >
              <span aria-hidden="true" role="presentation">×</span>
                </button>
                </div>
                                        <div style={{
                     marginTop:"20px",
                     fontSize: "16px",
                     fontWeight: "400",
                     fontFamily: "SuzukiPROBold",
                    
                  }}>
                                          
                                          <p>{props?.desktop_info}</p>
                                        </div>
                                      </div>
                                    )}
                                  </div>
          ) : (
            <>
            {/* {isLoading && !hideImage && <Skeleton containerClassName="flex-1" height={1004} width="100%" />} */}
            {!hideImage && (
              <div style={{ height: "calc(100vh - 180px)" }}>  
            <Image
              src={props.image}
              height={!isLoading?1004:0}
              // width={!isLoading?1928:0}
              objectFit="cover" 
              layout="fill" 
              alt={props?.page==="ro-history" ? props?.alt : props.alt_image || (props?.image ? `Suzuki_${props?.image?.split("/").pop()?.split(".")[0]}` : "")}
              className={`${styles.bannerImage} ${isLoading ? "hidden" : "block"}`}
              onLoad={() => setIsLoading(false)}
              onError={() => setHideImage(true)}
            />
            <div className="mp_overlay_banner light-grad"></div>
            </div>
             )} 
            </>
          )}
        </div>

        <div className={styles.bannerConts}>
        <div className="banner-content container">
            {props.isTitlePresent && props.isTitleVisible ?
              <h3
            className={`${styles.banner_content_head} ${props.head == "e VITARA" ? styles.no_uppercase : ""}`}
              style={{
                color: props.titleThemeData?.titleColor,
                fontSize:
                  windoWidth.width > 1024
                    ? props.titleThemeData?.titleFontSize
                    : "",
              }}
            >
              {props.head}
            </h3> :
            <h1
            className={`${styles.banner_content_head} ${props.head == "e VITARA" ? styles.no_uppercase : ""}`}
              style={{
                color: props.titleThemeData?.titleColor,
                fontSize:
                  windoWidth.width > 1024
                    ? props.titleThemeData?.titleFontSize
                    : "",
              }}
            >
              {props.head}
            </h1>}
          </div>
        </div>
      </div>
    </>
  );
};

export default FinanceBanner;
